import PropTypes from 'prop-types';
import React from 'react';
import {
  trackEvent,
  MParticleEventName,
} from '@reverbdotcom/commons/src/elog/mparticle_tracker';
import CoreLink from '@reverbdotcom/commons/src/components/core_link';

const COMPONENT_NAME = 'KeepShoppingLink';

class KeepShopping extends React.Component {
  componentDidMount() {
    trackEvent({
      eventName: MParticleEventName.ViewedKeepShoppingLink,
      componentName: COMPONENT_NAME,
    });
  }

  render() {
    return (
      <CoreLink
        className={this.props.class}
        to={this.props.lastSearchUrl}
        clickEvent={{
          eventName: MParticleEventName.ClickedKeepShoppingLink,
          componentName: COMPONENT_NAME,
        }}
      >
        {this.props.ctaText}
      </CoreLink>
    );
  }
}

KeepShopping.propTypes = {
  lastSearchUrl: PropTypes.string,
  ctaText: PropTypes.string,
  class: PropTypes.string,
};

export default KeepShopping;
